import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import {
  getTourHomePath,
  getTourRole,
  isTourHomePath,
  requestTourReplay,
} from '../tours/siteTours';

/**
 * Меню профиля в стиле масобр: имя видно снаружи, «Выйти» внутри выпадашки.
 */
export default function UserAccountMenu({ user, onLogout }) {
  const navigate = useNavigate();
  const location = useLocation();

  if (!user) return null;

  const tourRole = getTourRole(user);

  function startSiteTour(e) {
    if (!tourRole) return;
    const details = e.currentTarget.closest('details');
    if (details) details.open = false;
    const home = getTourHomePath(tourRole);
    requestTourReplay(tourRole, 'map');
    if (!isTourHomePath(tourRole, location.pathname)) {
      navigate(home);
    }
  }

  return (
    <details className="account-menu">
      <summary className="account-menu-toggle" aria-label="Меню профиля">
        <span className="account-menu-avatar" aria-hidden>
          👤
        </span>
        <span className="account-menu-username">{user.username}</span>
      </summary>
      <div className="account-menu-dropdown">
        <NavLink to="/profile" className="account-menu-item">
          Профиль
        </NavLink>
        <NavLink to="/settings/editor" className="account-menu-item">
          Настройки редактора
        </NavLink>
        {user.is_student && (
          <NavLink to="/questionnaire" className="account-menu-item">
            {user.has_questionnaire ? 'Анкета' : 'Заполнить анкету'}
          </NavLink>
        )}
        {!user.is_teacher && (
          <NavLink to="/billing" className="account-menu-item">
            Баланс и оплата
          </NavLink>
        )}
        {tourRole ? (
          <button type="button" className="account-menu-item" onClick={startSiteTour}>
            Как устроен сайт
          </button>
        ) : null}
        <button type="button" className="account-menu-item account-menu-logout" onClick={onLogout}>
          Выйти
        </button>
      </div>
    </details>
  );
}
